import { render, staticRenderFns } from "./PlainButton.vue?vue&type=template&id=45d3b337&scoped=true&"
import script from "./PlainButton.vue?vue&type=script&lang=js&"
export * from "./PlainButton.vue?vue&type=script&lang=js&"
import style0 from "./PlainButton.vue?vue&type=style&index=0&id=45d3b337&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d3b337",
  null
  
)

export default component.exports